import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import TrustBar from "@/components/TrustBar";
import { LOCAL_BUSINESS_JSON_LD } from "@/lib/seo";

const ProcessSection = lazy(() => import("@/components/ProcessSection"));
const ServicesSection = lazy(() => import("@/components/ServicesSection"));
const BeforeAfterSection = lazy(() => import("@/components/BeforeAfterSection"));
const TestimonialsSection = lazy(() => import("@/components/TestimonialsSection"));
const GallerySection = lazy(() => import("@/components/GallerySection"));
const WatchAndLearnSection = lazy(() => import("@/components/WatchAndLearnSection"));
const WhyShineBright = lazy(() => import("@/components/WhyShineBright"));
const BookingFormSection = lazy(() => import("@/components/BookingFormSection"));
const FAQSection = lazy(() => import("@/components/FAQSection"));
const SocialMediaSection = lazy(() => import("@/components/SocialMediaSection"));
const MapSection = lazy(() => import("@/components/MapSection"));
const Footer = lazy(() => import("@/components/Footer"));
const ChatWidget = lazy(() => import("@/components/ChatWidget"));
const MobileCTABar = lazy(() => import("@/components/MobileCTABar"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background" id="main-content">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(LOCAL_BUSINESS_JSON_LD) }}
      />
      <Navbar />
      <HeroSection />
      <TrustBar />
      <Suspense fallback={null}>
        <ProcessSection />
        <ServicesSection />
        <BeforeAfterSection />
        <TestimonialsSection />
        <GallerySection />
        <WatchAndLearnSection />
        <WhyShineBright />
        <BookingFormSection />
        <FAQSection />
        <SocialMediaSection />
        <MapSection />
        <Footer />
        <ChatWidget />
        <MobileCTABar />
      </Suspense>
    </div>
  );
};

export default Index;
